export const Footer = () => {
  return (
    <footer className="relative bg-white py-12 bg-footer bg-no-repeat bg-center bg-cover md:bg-contain lg:bg-repeat" />
  );
};
